import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { User } from '@ubie/core';

@Component({
  selector: 'acl-installation-installer-item',
  standalone: false,
  templateUrl: './installation-installer-item.component.html',
  styleUrl: './installation-installer-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationInstallerItemComponent {
  readonly installer = input<User | null>(null);
  readonly titleKey = input<string>('');
  readonly emptyKey = input<string>('');
  readonly canDelete = input<boolean>(false);
  readonly canAdd = input<boolean>(false);
  readonly addSlot = input<1 | 2>(1);

  readonly deleteInstaller = output<void>();
  readonly addInstaller = output<1 | 2>();

  hasInstaller(): boolean {
    return Boolean(this.installer());
  }
}
